import type { ApiClient, BackendProvider } from './types';
import { createSupabaseApiClient } from './supabase-api-client';

const provider = (import.meta.env.VITE_BACKEND_PROVIDER ?? 'supabase') as BackendProvider;

const buildApiClient = (): ApiClient => {
  if (provider === 'supabase') {
    return createSupabaseApiClient();
  }

  return createSupabaseApiClient();
};

export const apiClient = buildApiClient();
